import * as React from 'react';

export interface IRelatedLinksProps {
    items: LinkItem[];
}

class LinkItem {
    public title: string;
    public url: string;
}

export class RelatedLinks extends React.Component<IRelatedLinksProps> {
    private url: string;

    constructor(props: IRelatedLinksProps) {
        super(props);
    }

    public renderItem(item: LinkItem, index: number): JSX.Element {
        return (
            <li key={index}>
                <i className="icon-angle-up icon-rotate-90" />
                <a href={item.url}>{item.title}</a>
            </li>
        );
    }

    public render(): JSX.Element {
        return <ul className="page-links">{this.props.items.map(this.renderItem)}</ul>;
    }
}
